import { render } from "./_object-help-email-modal.vue?vue&type=template&id=0ac845c3"
import script from "./_object-help-email-modal.vue?vue&type=script&lang=js"
export * from "./_object-help-email-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__